import { StyleSheet } from 'aphrodite'

import editor from './editor'
import input from './input'
import ColorBlind from './ColorBlind'

export default {
  editor: StyleSheet.create(editor),
  input: StyleSheet.create(input),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/News/partials/PostEditor/style/index.js